/* import __COLOCATED_TEMPLATE__ from './ghost-field.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();